module.exports = __webpack_public_path__ + "img/receipt14.d367fc1c.png";